
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/free/[[...slug]]",
      function () {
        return require("private-next-pages/courses/free/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/free/[[...slug]]"])
      });
    }
  